import * as React from "react";
import type { SVGProps } from "react";
const SvgPrimaryRetinol = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 21 20"
    width="1em"
    height="1em"
    role="img"
    focusable={false}
    {...props}
  >
    <path
      stroke="#1D1D1D"
      strokeWidth={0.575}
      d="M12.433 8.32h.287c.318 0 .575.257.575.575v9.28c0 .174-.08.34-.233.426-.388.218-1.263.6-2.642.6s-2.254-.382-2.642-.6a.48.48 0 0 1-.233-.427v-9.28c0-.317.257-.574.575-.574h.287m4.026 0V5.368a.575.575 0 0 0-.575-.575m.575 3.527s-.66.544-2.013.544-2.013-.544-2.013-.544m3.45-3.527s-.625.282-1.437.282-1.438-.282-1.438-.282m2.876 0V3.1c1.15 0 1.437-.288 1.437-.71 0-.423-.287-.728-1.437-.728v-.15a.4.4 0 0 0-.117-.297C11.564 1.055 11.164.8 10.42.8s-1.144.255-1.321.415a.4.4 0 0 0-.117.298v3.28m0 0a.575.575 0 0 0-.575.575V8.32"
    />
  </svg>
);
export default SvgPrimaryRetinol;
